import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Box, Typography } from "@mui/material";
const backgroundColors = [
  "#64B5F6", // Darker Light Blue
  "#F48FB1", // Darker Light Pink
  "#81C784", // Darker Light Green
  "#FF8A65", // Darker Light Deep Orange
  "#A1887F", // Darker Light Brown
  "#9575CD", // Darker Light Indigo
  "#4DD0E1", // Darker Light Cyan
  "#CE93D8", // Darker Light Purple
  "#FFB74D", // Darker Light Orange
  "#AED581", // Darker Light Green
  "#90A4AE", // Darker Light Blue Gray
  "#E57373", // Darker Light Red
  "#66BB6A", // Darker Light Dark Green
  "#EC407A", // Darker Light Dark Pink
  "#42A5F5", // Darker Light Dark Blue
  "#26A69A", // Darker Light Teal
  "#AB47BC", // Darker Light Bright Purple
  "#FDD835", // Darker Light Yellow
  "#7E57C2", // Darker Light Deep Purple
  "#6D4C41", // Darker Light Dark Brown
];

export const getPLTableHeader = (response) => {
  if (!response || response.length === 0) return [];

  const keys = Object.keys(response[0]).filter(
    (key) =>
      key !== "particular" &&
      key !== "color" &&
      key !== "parent" &&
      key !== "showNow" &&
      key !== "bold" &&
      key !== "child"
  );

  const headers = [
    {
      label: "Particulars",
      id: "particular",
      width: 250,
      render: (data) => {
        return (
          <Box sx={{ width: "100%" }}>
            <Typography
              sx={{
                color: data.color && data.color,
                marginLeft: data.nestedLevel && `${data.nestedLevel}0px`,
              }}
            >
              {data.particular}
            </Typography>
          </Box>
        );
      },
      freeze: true,
    },
  ];

  keys.forEach((key, index) => {
    headers.push({
      label: key?.split("~")[0] || key,
      id: key.toLowerCase().replace(/\s+/g, "-"),
      background: key?.split("~")[2] || "#BBDEFB",
      columns: [
        {
          label: "Store Count",
          id: "storeCount",
          render: (data) => {
            const n = Number(data[key]?.value?.replace(/,/g, ""));
            const getIcon = () => {
              if (n === 0) {
                return (
                  <ArrowRightIcon
                    sx={{ color: "#e3e5e8", margin: "-10px 0px -10px -10px;" }}
                    fontSize="large"
                  />
                );
              }
              if (n > 0) {
                return (
                  <ArrowDropUpIcon
                    sx={{ color: "#4caf50", margin: "-10px 0px -10px -10px;" }}
                    fontSize="large"
                  />
                ); // green up
              }
              if (n < 0 && n >= -5) {
                return (
                  <ArrowRightIcon
                    sx={{ color: "#fbc02d", margin: "-10px 0px -10px -10px;" }}
                    fontSize="large"
                  />
                ); // yellow right
              }
              return (
                <ArrowDropDownIcon
                  sx={{ color: "#f44336", margin: "-10px 0px -10px -10px;" }}
                  fontSize="large"
                />
              ); // red down
            };
            return (
              <Box
                sx={{
                  display: "flex",                  
                  justifyContent:"space-between",
                  width: "110px",                  
                }}
              >
                {key?.includes("v/s") ? getIcon() :  <span></span>}
                <span
                  style={
                    data[key]?.parent
                      ? {
                          color: data[key]?.value?.includes("%")
                            ? "blue"
                            : "green",
                        }
                      : { fontWeight: data?.bold && "bold" }
                  }
                >
                  {data[key]?.value || "-"}
                </span>
              </Box>
            );
          },
        },
        {
          label: key?.split("~")[1] || "-",
          id: "percentage",
          render: (data) => {
            const n = data[key]?.percentage || 0;
            const getIcon = () => {
              if (n === 0) {
                return (
                  <ArrowRightIcon
                    sx={{
                      color: "#e3e5e8",
                      margin: "-10px 0px -10px -10px;",
                    }}
                    fontSize="large"
                  />
                );
              }
              if (n > 0) {
                return (
                  <ArrowDropUpIcon
                    sx={{ color: "#4caf50", margin: "-10px 0px -10px -10px;" }}
                    fontSize="large"
                  />
                ); // green up
              }
              if (n < 0 && n >= -5) {
                return (
                  <ArrowRightIcon
                    sx={{ color: "#fbc02d", margin: "-10px 0px -10px -10px;" }}
                    fontSize="large"
                  />
                ); // yellow right
              }
              return (
                <ArrowDropDownIcon
                  sx={{ color: "#f44336", margin: "-10px 0px -10px -10px;" }}
                  fontSize="large"
                />
              ); // red down
            };
            return (
              <Box
                sx={{
                  display: "flex",
                  // flexDirection:'row-reverse',
                  justifyContent:"space-between",
                  width: "110px",
                }}
              >
                {key?.includes("v/s") ? getIcon() : <span></span>}
                <span
                  style={
                    data[key]?.parent
                      ? { color: "blue", fontStyle: "italic" }
                      : { fontWeight: data?.bold && "bold" }
                  }
                >
                  {typeof data[key]?.percentage === "number"
                    ? `${(data[key]?.percentage).toFixed(1)}%`
                    : data[key]?.percentage || "-"}
                </span>
              </Box>
            );
          },
        },
      ],
    });
  });

  return headers;
};

export const getTrendsHeader = (data = [], region) => {
  if (!data || data.length === 0) return [];
  const cleanRegion = region.replace("-percentage", "");

  const fixedCols = [
    {
      label: cleanRegion,
      id: "particular",
      width: 200,
      freeze: true,
    },
  ];

  const groupColors = {
    MTD: "#e3f2fd",
    QTD: "#e8f5e9",
    YTD: "#fce4ec",
    Default: "#f9f9f9",
  };

  const firstRow = data[0];
  const groups = {};

  ["MTD", "QTD", "YTD"].forEach((group) => {
    if (firstRow[group] && Array.isArray(firstRow[group])) {
      groups[group] = firstRow[group].map((item) => ({
        label: item.key,
        id: `${group}-${item.key}`, // matches flattened row keys
        render: (row) => {
          const value = row[`${group}-${item.key}`] ?? "-"; // ✅ use flat key
          const isComparison = item.key.startsWith("v/s");

          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                minWidth: "130px",
              }}
            >
              <span style={{ color: isComparison ? "blue" : "inherit" }}>
                {value}
              </span>
            </Box>
          );
        },
      }));
    }
  });

  const dynamicCols = Object.keys(groups).map((group) => {
    return {
      label: group,
      id: group,
      background: groupColors[group] || groupColors.Default,
      columns: groups[group].map((col) => ({
        ...col,
        headerBackground: col.label.includes("v/s") ? "#ffe0b2" : undefined, // 🔥 custom header color
      })),
    };
  });

  return [...fixedCols, ...dynamicCols];
};

export const EXPENSE_ITEMS = [
  "ADS",
  "ADT",
  "APC",
  "Store Days",
  "Revenue",
  "Dine-in Revenue",
  "Dine-in ADS",
  "Dine-in ADT",
  "Dine-in APC",
  "Delivery Revenue",
  "Delivery ADS",
  "Delivery ADT",
  "Delivery APC",
  "Delivery%",
  "COGS",
  "Royalty",
  "Occupancy",
  "Rent Store",
  "CAM Charges",
  "Rent - Others",
  "Property Tax",
  "Labour",
  "Allied Labour",
  "Staff Incentive",
  "MIT",
  "Satish Jha Register",
  "Talentcabin India Pvt Ltd",
  "Store Employee Health Checkup",
  "BGV",
  "Store - Term Insurance & GPA Charges",
  "Service Charges - NAPS",
  "Employee Meal",
  "Store Staff Welfare",
  "Misc . Other Expense",
  "Utilities",
  "Electricity / HVAC",
  "Water",
  "Utility - Others",
  "Delivery Commission",
  "Other Opex",
  "AMC",
  "Insurance - Stores",
  "License Exp- Stores",
  "Printing & Stationery Expenses",
  "Uniform",
  "Cleaning & Consumables",
  "Pest Control",
  "Ecosure Audit Cost",
  "R&M",
  "Finance Charges - Stores",
  "QR Code Charges",
  "Travel and Conveyance",
  "ODC Expenses - Store",
  "Coffee Machine Rental",
  "Legal & Professional",
  "One time supplies",
  "Smallware",
  "Other Expenses",
  "Tech Cost",
  "Tech Fees - POSist",
  "IT License Expenses - Antivirus + Email",
  "Internet  + Telephone / Communication Expenses",
  "R&M - IT (Store IT Maintenance)",
  "Auto Failover Backup",
  "QR Ordering Fees - POSist",
  "Tab Ordering - 2nd POS",
  "Self Order Kiosk Charges",
  "CCTV Surveillance Charges",
  "IP Cost",
  "One time internet installation  charges",
  "Network Switches",
  "Loyalty",
  "Whatspp Bot",
  "Other Tech Related Costs",
  "Operating EBITDA",
  "Marketing",
  "EBITDA",
];
